import React from 'react';
import Board from 'react-trello';
import { getColumnsWithBookings } from './logic/columnLogic';
import { momentArray } from '../../common/helpers';
import GarageFocusAllocationCard from './components/GarageFocusAllocationCard';
import FilterBar from '$app/shared/components/FilterBar';
import DateRangeFilter from '$app/shared/components/DateRangeFilter';
import CndSelectFilter from '$app/shared/components/CndSelectFilter';
import GarageFilter from '$app/shared/components/GarageFilter';

const GarageFocusAllocation = ({ garages, bookings, earliestBookingDate, filters }) => {
  const {
    filteredDateRange,
    filteredGarage,
    filteredCndType,
    setFilteredGarage,
    setFilteredDateRange,
    setFilteredCndType,
    clearAllFilters,
  } = filters;

  const columnsWithBookings = getColumnsWithBookings(bookings?.bookingsForGarageAllocate || [], {
    filteredGarage,
    filteredDateRange,
    filteredCndType,
  });

  return (
    <div className="allocation-page garage-focus">
      <FilterBar
        mainFilters={
          <>
            <GarageFilter
              className="garage-focus"
              onSelect={setFilteredGarage}
              value={filteredGarage}
              garages={garages}
            />
            <DateRangeFilter
              onChange={setFilteredDateRange}
              value={momentArray(filteredDateRange)}
              earliestSelectableDate={earliestBookingDate}
            />
            <CndSelectFilter onChange={setFilteredCndType} value={filteredCndType} />
          </>
        }
        onClearFilters={clearAllFilters}
      />
      <div className="allocation-grid">
        <Board
          data={{ lanes: columnsWithBookings }}
          components={{
            Card: GarageFocusAllocationCard,
          }}
        />
      </div>
    </div>
  );
};

export default GarageFocusAllocation;
